import { useState } from 'react'
import { Alert, Box, Button, Typography } from '@mui/material'
import { Game } from 'model/Game'
import { Report } from 'model/Report'
import { Chat } from 'model/Chat'
import { User } from 'model/User'
import { useMediaContext } from 'context/MediaContext'

import * as badUserRepository from 'repository/BadUserRepository'

export type Props = {
  user: User
  opponent: User
  game: Game
  report: Report
  chat: Chat
  reportedEmpty: boolean
  reportedByLoser: boolean
  isNotMatchFormat: boolean
}
export default function Alerts(props: Props) {
  const { isPc } = useMediaContext()
  const alertStyle = { backgroundColor: 'background.default', mb: isPc ? 2 : 1 }

  const notYetReported = !props.report.uuid
  const waitingOpponentsAgreement = props.report.uuid === props.user.uuid && props.report.agreed === null
  const needsToNegotiate = props.report.agreed === false

  const autoAgreement = props.report.auto_agreed && props.report.uuid !== props.user.uuid

  const disagreedSameUser = props.report.agreed === false &&
    (props.report.history?.length ?? 0) >= 3 &&
    Array.from(new Set(props.report.history!.slice(-3))).length === 1

  const completed = (props.report.agreed === true) || (!!props.game.winner)
  const calculating = completed && !props.game.end_time

  const [isBadBhvReport, setIsBadBhvReport] = useState(false)

  return (
    <Box sx={{mx: isPc ? 5 : 2}}>
      {notYetReported &&
        <Alert variant='outlined' severity='info' sx={alertStyle}>ルームを作成して対戦し、勝者は先後と勝敗を記録して報告してください。</Alert>
      }
      {waitingOpponentsAgreement &&
        <Alert variant='outlined' severity='info' sx={alertStyle}>
          <Typography variant='body2'>対戦結果を報告しました。</Typography>
          <Typography variant='body2'>対戦相手の承認を待っています。（10分程度で自動承認されます。）</Typography>
        </Alert>
      }
      {props.reportedEmpty &&
        <Alert variant='outlined' severity='warning' sx={alertStyle}>対戦結果を記録してください。</Alert>
      }
      {props.reportedByLoser &&
        <Alert variant='outlined' severity='warning' sx={alertStyle}>報告は勝者が行ってください。</Alert>  
      }
      {props.isNotMatchFormat &&
        <Alert variant='outlined' severity='warning' sx={alertStyle}>試合数がフォーマットに則していません。</Alert>  
      }
      {needsToNegotiate && !disagreedSameUser &&
        <Alert variant='outlined' severity='warning' sx={alertStyle}>
          <Typography variant='body2'>結果が承認されませんでした。</Typography>
          <Typography variant='body2'>チャットで状況を整理して、正しい結果を再度報告してください。</Typography>
        </Alert>
      }
      {autoAgreement &&
        <Alert variant='outlined' severity='warning' sx={alertStyle}>報告から一定時間が経過したため自動承認しました。</Alert>  
      }
      {completed &&
        <Alert variant='outlined' sx={alertStyle}>対戦お疲れさまでした。</Alert>
      }
      {calculating &&
        <Alert variant='outlined' severity='info' sx={alertStyle}>レート計算・更新中です。</Alert>
      }
      {disagreedSameUser &&
        <>
          <Alert variant='outlined' severity='error' sx={alertStyle}>
            {isBadBhvReport ? '対戦相手を通報しました。' : '同一ユーザーによる承認拒否が続いたため、対戦が無効になりました。'}
          </Alert>
          <Button
            variant='outlined'
            color='error'
            fullWidth
            size='large'
            sx={{ mb: 2, bgcolor: 'background.default' }}
            disabled={isBadBhvReport}
            onClick={() => {
              setIsBadBhvReport(true)
              badUserRepository.save({
                uuid: props.opponent.uuid,
                reported_time: new Date().getTime()
              })
            }}
          >
            対戦相手を通報する
          </Button>
        </>
      }
    </Box>
  )
}